/** Entity lists the rule editors pick from (cached; refreshed by engine events through the shared keys). */

import type { Rule, ScoringRule, Source, Tag, Topic } from '@digester/core';
import { useEngineQuery } from '../../engine-client/EngineProvider.js';
import { qk } from '../../engine-client/keys.js';

export function useTags(): Tag[] {
  return useEngineQuery(qk.tags(), (e) => e.tags.list()).data ?? [];
}

export function useTopics(): Topic[] {
  return useEngineQuery(qk.topics(), (e) => e.topics.list()).data ?? [];
}

export function useSources(): Source[] {
  return useEngineQuery(qk.sources(), (e) => e.sources.list()).data ?? [];
}

/** Live scoring rules in evaluation order, then archived ones (rules.list). */
export function useScoringRules(): { rules: ScoringRule[]; isLoading: boolean } {
  const q = useEngineQuery(qk.rules('scoring'), (e) => e.rules.list('scoring'));
  return { rules: q.data ?? [], isLoading: q.isLoading };
}

export function useFilterRules(): { rules: Rule[]; isLoading: boolean } {
  const q = useEngineQuery(qk.rules('filter'), (e) => e.rules.list('filter'));
  return { rules: q.data ?? [], isLoading: q.isLoading };
}
